import React from "react";
import PropTypes from "prop-types";
import { FormikCheckbox, ExpandableTextContainer } from "@qgiv/core-donor";
import { validateWaiver } from "./formik/validation";

const Waiver = ({
    additionalText = "",
    isVisible,
    showMoreLink,
    showLessLink,
    subsectionHeading,
    waiverCheckbox,
    waiverText,
}) =>
    isVisible && (
        <div className="grid">
            <div className="col col--12">
                <h3 className="-type--regular -margin-bottom--5">
                    {subsectionHeading}
                </h3>
                {additionalText && <small>{additionalText}</small>}
            </div>
            <div className="col col--12 col--no-top-gutter">
                <FormikCheckbox
                    id="Accept-Waiver"
                    name="Accept_Waiver"
                    validate={validateWaiver}
                >
                    {waiverCheckbox}
                </FormikCheckbox>
                <ExpandableTextContainer
                    showMoreLink={showMoreLink}
                    showLessLink={showLessLink}
                    expandableText={waiverText}
                />
            </div>
        </div>
    );

Waiver.propTypes = {
    additionalText: PropTypes.string,
    isVisible: PropTypes.bool.isRequired,
    showLessLink: PropTypes.string.isRequired,
    showMoreLink: PropTypes.string.isRequired,
    subsectionHeading: PropTypes.string.isRequired,
    waiverCheckbox: PropTypes.string.isRequired,
    waiverText: PropTypes.string.isRequired,
};

export default Waiver;
